module.exports = __webpack_public_path__ + "media/public/images/about/experts/tretyakovskaya-66ab7814b31b4d36e37e54e5e219c1cd.svg";